// docs: https://github.com/altostra/type-validations#readme
import { objectOf /*, maybe */ } from "@altostra/type-validations";
import { string, number } from "@altostra/type-validations/lib/primitives";

export const isAppsUserInfoMergeDuplicateUsersRecordDatatableResult = objectOf({
  id: string,
  start_time: string,
  status: string,
  type: string,
  profiles_previewed_to_merge: number,
  profiles_merged: number,
  developer_name: string,
});

// example:
//
// const isChannelStat = objectOf({
//   total: number,
//   margin_of_error: maybe(number),
//   revenue: number,
// });
//
// export const isAppsAndFiltersPreview = objectOf<SegmentFilterReachableAudienceStatsPayload>({
//   distributed: boolean,
//   summary_statistics: objectOf({
//     estimated: boolean,
//     total_app_users: number,
//     total_segment_users: number,
//     total_segment_users_margin_of_error: maybe(number),
//     revenue_total_in_cents: maybe(number),
//     channel_statistics: maybe(
//       objectOf({
//         email: isChannelStat,
//         iosPush: isChannelStat,
//         androidPush: isChannelStat,
//         webPush: isChannelStat,
//         kindlePush: isChannelStat,
//       })
//     ),
//   }),
// });
